<script setup lang="ts">
import { computed, ref } from 'vue';

import { useAffiliateBannerQuery } from '@modules/affiliate-banner-view/queries';
import { useLocalStorage, watchImmediate } from '@vueuse/core';

import AffiliateBannerDialog from '../AffiliateBannerDialog/AffiliateBannerDialog.vue';

const isPreviewDialogVisible = ref(false);

const { data } = useAffiliateBannerQuery();

const bannerUpdatedAtStorage = useLocalStorage('banner', '', { writeDefaults: false });

const isDialogEnabled = computed<boolean>(() => (
  !!data.value?.banner && data.value?.banner.enabled && data.value?.banner.updated_at !== bannerUpdatedAtStorage.value
));

watchImmediate(isDialogEnabled, (isEnabled) => {
  isPreviewDialogVisible.value = isEnabled;
});

function onToggleDialog(): void {
  if (!isPreviewDialogVisible.value && data.value?.banner) {
    bannerUpdatedAtStorage.value = data.value.banner.updated_at;
  }
}
</script>

<template>
  <div v-data-qa-auto-id="'AffiliateBannerView'">
    <AffiliateBannerDialog
      v-model:visible="isPreviewDialogVisible"
      :image-url="data?.banner.image"
      :redirect-url="data?.banner.link"
      :close-on-escape="false"
      :dismissable-mask="false"
      @hide="onToggleDialog"
    />
  </div>
</template>
